<script setup>
import { computed } from "vue";

const props = defineProps({
  payment: {
    type: Object,
    required: true,
  },
});

const formatDateTime = (value) => {
  if (!value || value === "-") return "-";
  const safe = value.replace(" ", "T");
  return new Intl.DateTimeFormat("th-TH", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(safe));
};

const infoItems = computed(() => [
  { label: "เลขที่รับชำระ", value: props.payment.paymentNo },
  { label: "เลขที่ใบแจ้งหนี้", value: props.payment.invoiceNo },
  {
    label: "วันที่รับชำระ",
    value: formatDateTime(`${props.payment.paymentDate} 09:00`),
  },
  { label: "ผู้บันทึก", value: props.payment.recordedBy },
  { label: "ผู้ตรวจสอบ", value: props.payment.verifiedBy || "-" },
  { label: "เวลาตรวจสอบ", value: formatDateTime(props.payment.verifiedAt) },
]);

const statusText = (status) => {
  const map = {
    completed: "รับชำระสมบูรณ์",
    partial: "ชำระบางส่วน",
    pending_verify: "รอตรวจสอบ",
  };
  return map[status] || status;
};

const statusBadgeClass = (status) => {
  const map = {
    completed: "text-bg-success",
    partial: "text-bg-warning",
    pending_verify: "text-bg-secondary",
  };
  return map[status] || "text-bg-light";
};
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h5 class="fw-bold mb-1">ข้อมูลการรับชำระ</h5>
          <div class="text-muted small">
            รายละเอียดเอกสาร สถานะ และการบันทึกข้อมูล
          </div>
        </div>
        <span
          class="badge rounded-pill"
          :class="statusBadgeClass(payment.status)"
        >
          {{ statusText(payment.status) }}
        </span>
      </div>

      <div class="row g-3">
        <div class="col-md-6" v-for="item in infoItems" :key="item.label">
          <div class="label-text">{{ item.label }}</div>
          <div class="value-text">{{ item.value }}</div>
        </div>
      </div>

      <div class="mt-4 pt-4 border-top">
        <div class="label-text mb-2">หมายเหตุ</div>
        <div class="text-muted">{{ payment.note || "-" }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.label-text {
  font-size: 0.82rem;
  color: #6c757d;
  margin-bottom: 0.25rem;
}
.value-text {
  font-weight: 600;
}
</style>
